import React from "react";
import PropTypes from "prop-types";
import { Modal, Button } from "rhombus-react";

import ConflictsTable from "widgets/modals/assets/BulkUpload/ConflictsTable";

import "./AssetConflictModal.css";

export const ASSET_CONFLICT_RESOLUTIONS = {
	SKIP: "Skip",
	OVERWRITE: "overwriteExistingImages",
	USE_EXISTING: "useExistingImages",
};

export default function AssetConflictModal(props){
	const {
		creativeName,
		conflicts,
		commitResolution,
		onClose,
	} = props;

	function overwrite(){
		commitResolution(ASSET_CONFLICT_RESOLUTIONS.OVERWRITE);
		onClose();
	}

	function skip(){
		commitResolution(ASSET_CONFLICT_RESOLUTIONS.SKIP);
		onClose();
	}

	function useExisting(){
		commitResolution(ASSET_CONFLICT_RESOLUTIONS.USE_EXISTING);
		onClose();
	}

	function Content(){
		return (
			<div className="table-container">
				<p className="error-msg">
					The following assets already exist in the creative library
				</p>
				<ConflictsTable conflicts={conflicts} />
			</div>
		);
	}

	function Footer(){
		return (
			<div className="right-buttons">
				<Button onClick={skip}>Skip Creative</Button>
				<Button onClick={useExisting}>Use Existing Assets</Button>
				<Button theme="red" onClick={overwrite} >Overwrite Assets</Button>
			</div>
		);
	}

	const modalProps = {
		type: "modal",
		title: `Upload Creative Assets Error - ${creativeName}`,
		className: "asset-conflict-modal",
		setAppTitle: false,
		allowFullScreen: false,
		xClose: false,
		bladeProps: {
			verticallyCenter: true,
		},

		renderContent: Content,
		renderFooter: Footer,
	};

	return (
		<Modal {...modalProps} />
	);
}

AssetConflictModal.displayName = "AssetConflictModal";
AssetConflictModal.propTypes = {
	creativeName: PropTypes.string,
	conflicts: PropTypes.array,
	commitResolution: PropTypes.func,
	onClose: PropTypes.func,
};
